module.exports = __webpack_public_path__ + "img/bar2.dc120be0.png";